import { action } from 'typesafe-actions';
import { CargaDescargaTypes, CargaDescarga, CargaDescargaTotal } from './types';

export const loadRequestCargaDescarga = (dtInicio?: string, dtFim?: string) =>
  action(CargaDescargaTypes.LOAD_REQUEST_CARGA_DESCARGA, { dtInicio, dtFim });
export const loadSuccess = (data: CargaDescarga[], dataTotal: CargaDescargaTotal) =>
  action(CargaDescargaTypes.LOAD_SUCCESS_CARGA_DESCARGA, { data, dataTotal });
export const loadFailure = () => action(CargaDescargaTypes.LOAD_FAILURE_CARGA_DESCARGA, {});
export const cleanCargaDescarga = () => action(CargaDescargaTypes.CLEAN_CARGA_DESCARGA, {});
